
= <template>
    <ul class="List">
        <li
            v-for="({ key, name, function: code }, index) in data"
            :key="key"
        >
            <a
                class="Link"
                @click.prevent="handleClick(index)"
            >
                <div class="flex row-stretch-center">
                    <div class="Summary">
                        <WText color="accent-blue">
                            {{ key }}
                        </WText>
                        <WText class="mb-0">
                            {{ name }}
                        </WText>
                    </div>
                    <WIcon
                        icon="chevron-down"
                        :size="24"
                        :class="{ rotate: selected === index }"
                    />
                </div>
            </a>
            <Collapse :opened="selected === index">
                <WCode
                    :value="code"
                    name="code"
                    :placeholder="$t('entities.creation.placeholder.defaultExpression')"
                    readonly
                    class="pt-1 pl-1 pr-1"
                />
            </Collapse>
        </li>
    </ul>
</template>

<script>
import VueTypes from 'vue-types'
import { Collapse } from '@/components'

const SELECTED_DEFAULT = -1

export default {
    name: 'ListFunctions',
    components: {
        Collapse,
    },
    props: {
        data: VueTypes.arrayOf(VueTypes.shape({
            key: VueTypes.oneOfType([VueTypes.string, VueTypes.number]),
            name: VueTypes.oneOfType([VueTypes.string, VueTypes.number]),
            code: VueTypes.string,
        })).loose,
    },
    data () {
        return {
            selected: SELECTED_DEFAULT,
        }
    },
    methods: {
        handleClick (selected) {
            this.selected = (this.selected !== selected ? selected : SELECTED_DEFAULT)
        },
    },
}
</script>

<style lang="scss" scoped>
.List {
    margin: 0;
    padding: 0;
    list-style: none;

    li + li {
        margin-top: 15px;
        padding-top: 15px;
        border-top: 1px solid $gray-05;
    }

    .WText {
        margin-bottom: 8px;
    }

    .Link {
        display: block;
        padding: 0 15px;
    }

    .WIcon {
        transition: all 350ms ease;
        &.rotate {
            transform: rotate(-180deg);
        }
    }
}
</style>
